import axios from 'axios';
import { serverUrl } from '../../ApiRoute';
import store from '../redux';
import { loadHouse } from '../redux/action/CollectiveHouse';

/** Subscription-cloud route that re-parents a device to another house. */
export const MOVE_DEVICE_ROUTE = '/v2/admin/misc/moveBistroDevice';

/**
 * Moves a single device from one house to another.
 * The route keys off the device id alone — the room it lands in is decided
 * server side, so there is nothing else to send.
 */
export const moveDevice = async ({ deviceId, oldHouseId, newHouseId }) => {
  try {
    const response = await axios.post(
      `${serverUrl.sub}${MOVE_DEVICE_ROUTE}`,
      { deviceId, oldHouseId, newHouseId },
      { headers: { 'Content-Type': 'application/json' } }
    );

    if (response.status === 200 && response.data?.success !== false) {
      return { success: true, message: response.data?.message || 'Device moved successfully' };
    }

    return { success: false, message: response.data?.message || 'Could not move the device' };
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.data) {
      message = error.response.data.message || message;
    }
    return { success: false, message };
  }
};

/**
 * Loads a house into `mutipleHouse` so its rooms and devices can be listed.
 * Deliberately not `fetchHouseDetails` — that also rewrites the user's default
 * property, and picking a source or destination here is not the same as
 * switching the property the dashboard opens on.
 */
export const loadHouseForPicker = async (houseId, phoneNumber) => {
  try {
    const response = await axios.get(
      `${serverUrl.sub}/api/fetch/house2/${houseId}/+91${phoneNumber}?user=+91${phoneNumber}`
    );

    if (response.status === 200) {
      store.dispatch(loadHouse(houseId, response.data));
      return { success: true, data: response.data };
    }

    return { success: false, message: 'Could not load this property' };
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.data) {
      message = error.response.data.message || message;
    }
    return { success: false, message };
  }
};
